<template>
  <div>
    <base-header class="pb-6 bg-light">

      <div v-if="noAccess">
        <b-card>
          <b-card-header>
            <p class="h2 mb-2">
              <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
              >&nbsp;Restricted
            </p>
          </b-card-header>
          <b-card-body>Access is Restricted</b-card-body>
        </b-card>
      </div>

      <div v-else>
        <b-row align-v="center" class="py-4">
          <b-col cols="12" md="7" lg="6">
            <b-row>
              <b-col sm="6" md="5" xl="4">
                <h6 class="h2 d-inline-block mb-0 text-dark nowrap">eSIM Profile Info</h6>
              </b-col>
              <b-col sm="6" md="7" xl="8" class="text-sm-left text-right">
								<span v-if="hasData" :key="buttons_idx" class="nowrap">
									<base-button :type="getStateClass(profileStatus)" title="current state" size="sm">
										{{ profileStatus.toUpperCase() }}
									</base-button>
									<base-button
                      v-if="profileStatus === 'Released' || profileStatus === 'Allocated'"
                      type="white"
                      title="show qrcode"
                      size="sm"
                      v-on:click="showQrcode"
                  >
										<i class="fa fa-qrcode"></i>
									</base-button>
									<base-button
                      type="warning"
                      title="refresh profile"
                      size="sm"
                      v-on:click="refreshPage"
                  >
										<b-icon icon="arrow-clockwise"></b-icon>
									</base-button>
									<base-button
                      v-if="
											profileStatus === 'Released' ||
											profileStatus === 'danger' ||
											profileStatus === 'Allocated' ||
											profileStatus === 'Linked' ||
											profileStatus === 'Error'
										"
                      type="danger"
                      title="Cancel"
                      size="sm"
                      v-on:click="profileActionEvent('Cancel')"
                      :disabled="isReadOnly"
                  >
										<b-icon icon="x-circle"></b-icon> CANCEL
									</base-button>

                  <base-button
                      type="primary"
                      title="Order"
                      size="sm"
                      @click="showEsimOrderModal()"
                      v-if="profileStatus === 'Available'"
                      :disabled="isReadOnly">
                    <i class="fa fa-qrcode"></i> ORDER
                  </base-button>

									<EsimOrderModal
                      :iccid="iccid"
                  />

								</span>
              </b-col>
            </b-row>
          </b-col>

          <b-col cols="12" md="5" lg="6" class="text-right">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>

        <b-row>
          <b-col xl="6">
            <div class="input-group">
              <b-input-group>
                <template #prepend>
                  <b-input-group-text :style="ps" class="iccid-width">ICCID</b-input-group-text>
                </template>
                <b-form-input
                    id="iccid"
                    type="text"
                    v-model="iccid"
                    @change="loadPageData"
                ></b-form-input>
                <template #append>
                  <base-button size="lg" type="success" title="Search" v-on:click="loadPageData">
                    <i class="fa fa-search"></i>
                  </base-button>
                </template>
              </b-input-group
              >&nbsp;
            </div>
          </b-col>
        </b-row>

        <b-row v-if="!hasData">
          <b-col xl="12">
            <b-card no-body>
              <b-card-body>
                <div align="center">Please enter a valid iccid that exists in the system.</div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col xl="6">
            <b-card no-body>
              <b-card-body>
                <div class="">
                  <b-table
                      id="profile_table"
                      head-row-variant="primary"
                      :items="profile_data"
                      :fields="profile_fields"
                      fixed
                      show-empty
                      :key="profile_data_idx"
                      head-variant="light"
                      table-class="text-nowrap"
                      class="data-management-table primary-table"
                      sticky-header="true"
                      thead-class="white"
                      responsive
                      small
                  >
                    <template #cell(data_value)="row">
											<span v-if="row.item['data_name'] === 'Status'">
												<base-button
                            size="xs"
                            style="width: 100px"
                            :type="getStateClass(row.item['data_value'])"
                            title="current state"
                            class="nowrap"
                        >{{ row.item["data_value"].toUpperCase() }}</base-button
                        >
											</span>
                      <span v-else>{{ row.item["data_value"] }}</span>
                    </template>

                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
                </div>

                <div class="">
                  <b-table
                      id="sim_table"
                      head-row-variant="primary"
                      :items="sim_data"
                      :fields="sim_fields"
                      fixed
                      show-empty
                      :key="sim_data_idx"
                      head-variant="light"
                      table-class="text-nowrap"
                      class="data-management-table primary-table"
                      sticky-header="true"
                      thead-class="white"
                      responsive
                      small
                  >
                    <template #cell(data_value)="row">
											<span v-if="row.item['data_name'] === 'EID' && blacklisted">
												{{ row.item["data_value"] }}
												<base-button size="xs" type="danger">BLACKLISTED</base-button>
											</span>
                      <span v-else>{{ row.item["data_value"] }}</span>
                    </template>

                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col xl="6">
            <b-card no-body>
              <b-card-body>
                <div class="">
                  <table class="table b-table">
                    <tr>
                      <th colspan="2" class="primary-table-header">
                        <div class="">Activity Log</div>
                      </th>
                    </tr>
                  </table>
                  <b-table
                      id="activity_table"
                      head-row-variant="light"
                      :items="activity_data"
                      :fields="activity_fields"
                      :key="activity_data_idx"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      class="second-table"
                      show-empty
                      responsive
                      striped
                      hover
                  >
                    <template #cell(Modified)="row">
                      {{ cDate(row.item["Modified"]) }}
                    </template>
                    <template #cell(Status)="row">
                      <base-button
                          v-b-toggle.activity-sidebar-right
                          size="xs"
                          style="width: 100px"
                          :type="getStateClass(row.item['Status'])"
                          class="nowrap"
                          v-on:click="showActivitySelected(row.item.original)"
                      >
                        {{ row.item["Status"] }}
                      </base-button>
                    </template>
                    <!--              <template #cell(Details)="row">-->
                    <!--                <base-button size="xs" type="light" v-on:click="getActivityDetail(row.item['id'])">-->
                    <!--                  <b-icon icon="info-circle-fill" aria-label="More"></b-icon>-->
                    <!--                </base-button>-->
                    <!--              </template>-->

                    <template #empty="scope">
                      <div v-if="submitLoading" class="text-center">
                        <b-icon icon="three-dots" animation="cylon" font-scale="4"/>
                      </div>
                      <div v-else class="text-center">
                        <b>{{ scope.emptyText }}</b>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </base-header>

    <!-- ACTIVITY LOG DETAIL STARTS -->
    <b-sidebar id="activity-sidebar-right" width="360px" sidebar-class="border-left border-secondary" right shadow>
      <template #header>
        <section class="d-flex align-content-center w-100">
          <b-button v-b-toggle.activity-sidebar-right variant="light" class="p-0 shadow-none">
            <b-icon icon="x-lg" font-scale="1"/>
          </b-button>
          <div class="w-100 text-center font-weight-bolder">Activity Status</div>
        </section>
      </template>
      <b-card class="shadow-none">
        <b-card-text v-for="(item, i) of activity_selected" :key="i">
          <div class="font-weight-bold text-capitalize">
            {{ item.title }}
          </div>
          {{ item.value }}
        </b-card-text>
      </b-card>
    </b-sidebar>
    <!-- ACTIVITY LOG DETAIL ENDS -->

    <b-modal id="activityModal" size="xs" centered hide-footer>
      <template #modal-title> Log details</template>
      <div class="table-responsive">
        <table class="table-bordered" cellpadding="10" cellspacing="2">
          <tr>
            <td colspan="2">
              <b>Profile Management</b><br/>
              <i>{{ activity.invocationName }}</i
              ><br/>
            </td>
          </tr>
          <tr>
            <td class="bg-light">Profile-Id</td>
            <td>{{ this.iccid }}</td>
          </tr>
          <tr>
            <td colspan="2" class="bg-light"><b>Invocation</b><br/></td>
          </tr>
          <tr>
            <td class="bg-light">Date</td>
            <td>{{ activity.processingStart }}</td>
          </tr>
          <tr>
            <td class="bg-light">ID</td>
            <td>{{ activity.invocationId }}</td>
          </tr>
          <tr>
            <td class="bg-light">Duration</td>
            <td>({{ activity.duration }}) ms</td>
          </tr>
        </table>
      </div>
    </b-modal>

    <b-modal id="qrCodeModal" size="md" centered hide-footer class="bg-light text-black">
      <template #modal-title> QR Code</template>
      <div>
        <table>
          <tr>
            <td rowspan="4">
              <qrcode-vue :value="qrcodeSrc" size="100" level="H">
                {{ qrcodeSrc }}
              </qrcode-vue>
            </td>
            <td rowspan="4">&nbsp;</td>
            <td>ICCID</td>
            <td>
              <barcode :value="iccid" format="code128" width="2" height="20">
                {{ iccid }}
              </barcode>
            </td>
          </tr>
          <tr>
            <td>IMSI</td>
            <td>{{ imsi }}</td>
          </tr>
          <tr>
            <td>SM-DP+</td>
            <td>{{ smdpAddress }}</td>
          </tr>
          <tr>
            <td>Activation code</td>
            <td>{{ matchingId }}</td>
          </tr>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import eSimDashboardService from "@/common/api-services/esim-dashboard-service";
import moment from "moment";
import commonService from "@/common/api-services/common";
import initService from "@/common/api-services/init-service";
import authService from "@/common/api-services/auth-service";
import {v4 as uuidv4} from "uuid";
import ToastVue from "../../Components/Toast.vue";
import EsimOrderModal from "../../Components/Esim-Order-Modal.vue";

export default {
  components: {
    RouteBreadCrumb,
    barcode: VueBarcode,
    QrcodeVue,
    ToastVue,
    EsimOrderModal,
  },

  data() {
    return {
      submitLoading: false,
      hasData: false,
      ps: "background-color:rgba(94,114,228);color:#FFFFFF;width:150px",

      imsi: "",
      iccid: "",
      eid: "",
      smdpAddress: "smdp.io",
      matchingId: "",
      confirmationCode: "",
      profileType: "",
      finalProfileStatusIndicator: "Available",

      blacklisted: false,
      qrcodeSrc: null,
      barcodeSrc: null,

      //setup for alert
      alertShow: false,
      alertVariant: "success",
      alertMessage: "",

      //setup styles
      profileActionStyle: "danger",
      profileActionIcon: "x-circle",
      profileActionText: "Cancel",
      profileStatus: "Unknown",

      //DATA

      //selectected activity detail
      activity: {
        invocationId: "",
        invocationName: "",
        iccid: "",
        processingStart: "",
        processingEnd: "",
        duration: 0,
      },

      //buttons
      buttons_idx: 4000,

      //profile list
      profile_data_idx: 1000,
      profile_data_src: [],
      profile_data: [],
      profile_fields: [
        {key: "data_name", label: "Profile Details"},
        {key: "data_value", label: ""},
      ],

      //activity list
      activity_data_idx: 2000,
      activity_data_src: [],
      activity_data: [],
      activity_fields: [
        {key: "Modified", label: "Modified", sortable: true},
        {key: "Action", label: "Action", sortable: true},
        {key: "Status", label: "Status", sortable: true},
        //{key: 'Details', label: ''},
      ],
      activity_title: [{key: "title", label: "Activity Log"}],
      activity_selected: null,
      //sim list
      sim_data_idx: 3000,
      sim_data_src: [],
      sim_data: [],
      sim_fields: [
        {key: "data_name", label: "Sim Details"},
        {key: "data_value", label: ""},
      ],

      //ACCESS ROLES
      noAccess: true,
      isReadOnly: true,
      isEditor: false,
      isAdministrator: false,
      isPortalAdmin: false,

      // TABLE ACTIVITY LOG
      sortBy: "Modified",
      sortDesc: true,
      sortDirection: "desc",
    };
  },

  mounted() {
    document.title = "eSIM - Profile";

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    //The user needs to be notified that this is not accessible.
    this.noAccess =
        !initService.getUserRoles().includes("Administrator") &&
        !initService.getUserRoles().includes("ESIM_ADMIN") &&
        !initService.getUserRoles().includes("ESIM_READ") &&
        !initService.getUserRoles().includes("ESIM_EDIT");

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    this.isReadOnly = initService.getUserRoles().includes("ESIM_READ");
    this.isEditor = initService.getUserRoles().includes("ESIM_EDIT");
    this.isAdministrator =
        initService.getUserRoles().includes("Administrator") || initService.getUserRoles().includes("ESIM_ADMIN");
    this.isPortalAdmin = initService.getPortalAdminRole();

    //write to console.
    console.log("PAGE:", document.title);
    console.log("isReadOnly:", this.isReadOnly);
    console.log("isEditor:", this.isEditor);
    console.log("isAdministrator:", this.isAdministrator);
    console.log("isPortalAdmin:", this.isPortalAdmin);

    //don't do anything unless the user has access
    if (!this.noAccess) {

      this.$root.$on("esimProfileReloadPage", () => {
        this.refreshPage();
      });

      this.$root.$on("esimProfileToast", res => {
        this.showToasterMsg(res.msg, res.type, res.variant);
      });


      if (this.$route.query.iccid !== "" && typeof this.$route.query.iccid !== "undefined")
        this.iccid = this.$route.query.iccid;
      else this.readCache();
      this.loadPageData();
    }
  },

  methods: {

    cDate(str) {
      return commonService.strToDate(str);
    },

    readCache() {
      //get the last saved filter criteria
      let search = localStorage.getItem(this.$route.name);
      console.log("esim reading search:", search);
      if (search) {
        search = JSON.parse(search);
        if (search.iccid) this.iccid = search.iccid;
      }
    },

    writeCache() {
      //set to current filter criteria
      let search = {
        iccid: this.iccid,
      };
      console.log("esim writing search:", search);
      localStorage.setItem(this.$route.name, JSON.stringify(search));
    },

    async loadPageData() {
      try {
        if (!this.iccid || this.iccid.length !== 20) {
          throw new Error("Invalid ICCID.");
        } else {
          this.getProfileData();
          this.getActivityData();
          this.writeCache();
        }
      } catch (e) {
        //console.error(e);
        //this.showToasterMsg("[loadPage]Error:" + e.message, true, "danger");
        this.hasData = false;
      }
    },

    showEsimOrderModal() {
      this.$bvModal.show("eSimOrderModal");
    },

    showQrcode() {
      this.$bvModal.show("qrCodeModal");
      try {
        this.qrcodeSrc = "LPA:1$" + this.smdpAddress + "$" + this.matchingId;
        this.barcodeSrc = this.iccid;
        authService.setActivityLog("ESIM:showQrcode", "show qrcode OK: " + this.iccid, 0);
      } catch (e) {
        authService.setActivityLog("ESIM:showQrcode", JSON.stringify(e), 1);
        this.showToasterMsg("[showQrcode]Error:" + e.message, true, "danger");
      }
    },

    getStateClass(state) {
      return eSimDashboardService.getStateClass(state);
    },

    async getProfileData() {
      let profile_status = "Unknown";
      let myProfileType = "";
      this.submitLoading = true;
      await eSimDashboardService.getProfile(this.iccid).then(res => {
        //console.log(res.data);
        if (res.data) {
          this.profile_data_src = res;
          let d = [];
          Object.keys(res.data).forEach(function (data_key) {
            let data_val = "";
            if (data_key === "profileId") {
              data_val = res.data[data_key];
              data_key = "Profile ID";
            } else if (data_key === "profileType") {
              data_val = res.data[data_key];
              data_key = "Profile Template";
              myProfileType = data_val;
            } else if (data_key === "profileStatus") {
              data_val = res.data[data_key];
              data_key = "Status";
              profile_status = data_val;
            } else if (data_key === "lastModified") {
              data_val = moment(res.data[data_key]).format("YYYY/MM/DD hh:mm:ss");
              data_key = "Last Updated";
            } else if (data_key === "created") {
              data_val = moment(res.data[data_key]).format("YYYY/MM/DD hh:mm:ss");
              data_key = "Created";
            } else {
              data_key = "";
            }
            if (data_key !== "" && data_val !== "") {
              d.push({data_name: data_key, data_value: data_val});
            }
          });
          this.profileType = myProfileType;
          this.profile_data = d;
          this.profileStatus = profile_status;
          this.hasData = true;
        } else {
          this.hasData = false;
        }
      });
      await this.getSimData();
      this.submitLoading = false;
    },

    async getSimData() {
      let myEID, myMSISDN, myIMSI, myICCID, myMatchingId;
      //eSimDashboardService.getProfile(this.iccid).then(res => {
      let res = this.profile_data_src;
      if (res) {
        //this.sim_data_src = res.data;
        let d = [];
        Object.keys(res.data).forEach(function (data_key) {
          let data_val = "";
          if (data_key === "iccid") {
            data_val = res.data[data_key];
            data_key = "ICCID";
            myICCID = data_val;
          } else if (data_key === "profileOwner") {
            data_val = res.data[data_key];
            data_key = "EID";
            myEID = data_val;
          } else if (data_key === "matchingId") {
            data_val = res.data[data_key];
            data_key = "Matching ID";
            myMatchingId = data_val;
          } else if (data_key === "msisdn") {
            data_val = res.data[data_key];
            data_key = "MSISDN";
            myMSISDN = data_val;
          } else if (data_key === "imsi") {
            data_val = res.data[data_key];
            data_key = "IMSI";
            myIMSI = data_val;
          } else {
            data_key = "";
          }
          if (data_key !== "" && data_val !== "") {
            d.push({data_name: data_key, data_value: data_val});
          }
        });
        this.iccid = myICCID;
        this.imsi = myIMSI;
        this.eid = myEID;
        this.matchingId = myMatchingId;
        this.msisdn = myMSISDN;
        if (!myIMSI) d.push({data_name: "IMSI", data_value: "Not Set"});
        //if (!myEID) d.push({'data_name': 'EID', 'data_value': 'Not Set'});
        //if (!myMSISDN) d.push({'data_name': 'MSISDN', 'data_value': 'Not Set'});
        this.sim_data = d;
      }
      //});
    },

    async getActivityData() {
      eSimDashboardService
          .getProfileTransitions(this.iccid)
          .then(res => {
            this.activity_data_src = res;
            let d = [];
            res.data.transitions.forEach(item => {
              //invocationId
              let id = ""; //commonService.dateToInt(item['event_timestamp']);
              //Modified
              let m = Date.parse(item["event_timestamp"]);
              //Action
              let a = commonService.getLastKey(item["function"], ".", " ", true);
              //Status
              let s = String(item["new_state"]).toUpperCase();
              if (s === "UNDEFINED") s = "DELETED";
              //add row to data object
              d.push({id: id, Modified: m, Action: a, Status: s, original: JSON.parse(JSON.stringify(item))});
            });
            this.activity_data = d;
            // console.log('getActivityData',d);
          })
          .catch(err => {
            this.$toast.error(err.message);
          });
    },

    getActivityDetail(id) {
      eSimDashboardService.getActivityDetail(id).then(res => {
        //now show the model.
        res.invocationName = commonService.getLastKey(res.invocationName, ".", " ", true);
        res.duration = res.processingEnd - res.processingStart;
        this.activity = res;
        this.$bvModal.show("activityModal");
      });
    },

    profileActionEvent(event) {
      //clear params.
      this.cleanVariables();
      if (event === "Cancel") {
        //Cancel Order
        let msg =
            "You are about to cancel this profile. After this operation the profile should be back in Available state.";
        this.$bvModal
            .msgBoxConfirm(msg, {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "APPLY",
              cancelTitle: "CANCEL",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(value => {
              if (value === true) {
                //Cancel order successful
                eSimDashboardService
                    .cancelOrder(this.iccid, this.eid, this.matchingId, this.finalProfileStatusIndicator)
                    .then(res => {
                      //console.log('cancelOrder:',res.data);
                      let status = String(res.data.header.functionExecutionStatus.status);
                      authService.setActivityLog(
                          "ESIM:downloadConfirmOrder",
                          status + ": " + this.iccid,
                          0
                      );
                      if (status !== "Failed") {
                        this.showToasterMsg(" Cancel order successful " + this.iccid, true);
                        setTimeout(() => {
                          this.refreshPage();
                        }, 1000);
                      } else {
                        this.showToasterMsg(" Cancel order failed " + this.iccid, true, "danger");
                      }
                    });
              }
            })
            .catch(err => {
              authService.setActivityLog("ESIM:downloadConfirmOrder", JSON.stringify(err), 1);
              // An error occurred
              this.showToasterMsg(" Cancel order failed ", true, "danger");
            });
      } else if (event === "Blacklist") {
        //Blacklist device
        let msg =
            "You are about to blacklist the device with this profile.\n" +
            "  After this operation the device with EID " +
            this.eid +
            " will not be able to install any profiles.";
        this.$bvModal
            .msgBoxConfirm(msg, {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              okTitle: "APPLY",
              cancelTitle: "CANCEL",
              footerClass: "p-2",
              hideHeaderClose: false,
              centered: true,
            })
            .then(value => {
              if (value === true) {
                //Cancel order successful
                eSimDashboardService.addBlacklist(this.eid).then(res => {
                  //console.log("addBlacklist:", res);
                  if (!res) throw Error(res);
                  this.showToasterMsg(" Blacklist device successful ", true);
                  setTimeout(() => {
                    this.refreshPage();
                  }, 1000);
                });
              }
            })
            .catch(err => {
              // An error occurred
              this.showToasterMsg(" Blacklist device failed ", true, "danger");
            });
      } else {
        //NOT VALID
      }
    },

    refreshPage() {
      setTimeout(() => {
        //another way to refresh table data...
        //this.$root.$emit('bv::refresh::table', 'my-table');
        //this.$refs.table.refresh()

        this.profile_data_src = null;
        this.profile_data = null;
        this.sim_data_src = null;
        this.sim_data = null;
        this.activity_data_src = null;
        this.activity_data = null;
        this.submitLoading = true;
        this.loadPageData();
      }, 1000);
    },

    showToasterMsg(message, boolean, variant = "success") {
      //setup for alert
      this.$toast(
          {
            component: ToastVue,
            props: {
              description: message,
            },
          },
          {
            type: variant,
          }
      );
    },

    cleanVariables() {
      if (!this.imsi || this.imsi === "undefined") this.imsi = "";
      if (!this.iccid || this.iccid === "undefined") this.iccid = "";
      if (!this.eid || this.eid === "undefined") this.eid = "";
      if (!this.smdpAddress || this.smdpAddress === "undefined") this.smdpAddress = "";
      if (!this.matchingId || this.matchingId === "undefined") this.matchingId = "";
      if (!this.profileType || this.profileType === "undefined") this.profileType = "";
      if (!this.confirmationCode || this.confirmationCode === "undefined") this.confirmationCode = "";
      if (!this.finalProfileStatusIndicator || this.finalProfileStatusIndicator === "undefined")
        this.profileType = "Available";
    },

    showActivitySelected(item) {
      const informations = [];
      for (const key of Object.keys(item)) {
        if (!item[key]) continue;
        let title = "";
        let value = item[key];
        if (key == "event_timestamp") {
          title = "Date";
          value = commonService.strToDate(item[key]);
        } else if (key == "function") {
          title = "Action";
          value = commonService.getLastKey(item[key], ".", " ", true);
        } else {
          title = key.split("_").join(" ");
        }
        informations.push({title, value});
      }
      this.activity_selected = informations;
    },

    showDetails(detail) {
      if (detail === "Available") {
        eSimDashboardService.esimGetprofileinstallerrors(this.iccid).then(res => {
          if (res.data.errors.length) {
            let misMatch = res.data.errors[0].error_reason;
            this.$notify({
              title: "Handle Notification",
              message: `<div>
                            <div class="version">ES9</div>
                            <div class="id">ID : ${uuidv4()}</div>
                            <hr />
                            <div class="exclamation">
                              <i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>
                              <div class="d-block">
                                <div class="mismatch">REASON_INSTALL_FAILED_DUE_TO_ICCID_MISMATCH(${misMatch})</div>
                                <div class="unknown-reason">Unknown reason</div>
                              </div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <i class="fas fa-exclamation-circle text-danger" aria-hidden="true"></i>
                              <div class="d-block">
                                <div class="mismatch">STATUS_OK(0)</div>
                                <div class="unknown-reason">Unknown reason</div>
                              </div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <div class="notification-title">Notification</div>
                              <div class="notification-body">Profile Install Error</div>
                            </div>
                            <hr />
                            <div class="exclamation">
                              <div class="notification-title">Notification</div>
                              <div class="notification-body">profile-installation-error</div>
                            </div>
                            <hr />
                          </div>`,
              timeout: 45000,
              type: "white",
            });
          }
        });
      }
    },
  },
};
</script>
